import React, { useState, useEffect } from "react";

import { useGlobalContext } from "context/GlobalContext";
import { toast } from "react-toastify";

import { TYPE } from "constants";
import {
  updateDesignSystemDomainName,
  deleteDesignSystem,
  updateDesignSystemType,
  manageAccess,
  designSystemManageAccess,
  renameDesignSystem,
} from "api";

import EditDesignsystemsModal from "./EditDesignsystemsModal";
import SelectInput from "components/SelectInput";
import AuthAction from "components/auth/AuthAction";
import EditButton from "components/Buttons/EditButton";
import Tooltip from "components/Tooltip";
import Permission from "components/auth/Permission";
import UserImage from "components/Common/UserImage";
import ChangeDomainNameModal from "./ChangeDomainNameModal";
import ConfirmDialog from "components/Common/Confirm/ConfirmDialog";
import RenameModal from "components/Home/FileUpload/RenameModal";
import AddMemberModal from "./AddMemberModal";
import MenuDropdown from "components/MenuDropdown/MenuDropdown";
import TransferOwnershipModal from "components/Home/FileUpload/TransferOwnershipModal";
import { isUserAdmin } from "helpers/auth";
import { transferOwnership } from "api";

const DesignsystemsTableRaw = ({ row, setDesignSystems }) => {
  const context = useGlobalContext();
  const isAdmin = isUserAdmin();
  const { setLoading, designSystemMeta } = useGlobalContext();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [selectedRole, setSelectedRole] = useState();
  const [isUrlModalOpen, setURLModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [isPrivacyConfirmModalOpenOpen, setPrivacyConfirmModalOpenOpen] =
    useState(false);
  const [isDeleteConfirmModalOpenOpen, setDeleteConfirmModalOpenOpen] =
    useState(false);
  const [isRenameModalOpen, setRenameModalOpen] = useState(false);
  const [isAddMemberModalOpen, setAddMemberModalOpen] = useState(false);
  const [isTransferOwnershipModalOpen, setTransferOwnershipModalOpen] =
    useState(false);
  const [selectedPrivacyType, setSelectedPrivacyType] = useState();

  const closeTransferOwnershipModal = () => {
    setTransferOwnershipModalOpen(false);
  };
  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    setSelectedRole(row?.type);
    setSelectedPrivacyType(TYPE.find((t) => t.value === row?.type));
  }, []);

  const deleteState = (id) => {
    setDesignSystems((prevState) =>
      prevState.filter((designSystem) => designSystem.id !== id)
    );
  };

  const handleDeleteDesignSystem = async (id) => {
    try {
      setLoading(true);
      const data = await deleteDesignSystem(id);
      toast.success(data.message);
      deleteState(id);
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to delete the design system", error);
    } finally {
      setLoading(false);
    }
  };

  const updateState = (data) => {
    setDesignSystems((prevState) =>
      prevState.map((designSystem) => {
        if (designSystem.id !== data.design_system_id) {
          return designSystem;
        } else {
          return {
            ...designSystem,
            domain: { domain_name: data.domain_name },
          };
        }
      })
    );
  };
  const updateRenameState = (data) => {
    setDesignSystems((prevState) =>
      prevState.map((designSystem) => {
        if (designSystem.id !== data.id) {
          return designSystem;
        } else {
          return {
            ...designSystem,
            design_system_name: data.design_system_name,
          };
        }
      })
    );
    //update global context
    context.setDesignSystems((prevState) =>
      prevState.map((designSystem) => {
        if (designSystem.id !== data.id) {
          return designSystem;
        } else {
          return {
            ...designSystem,
            design_system_name: data.design_system_name,
          };
        }
      })
    );
  };
  const updateMamanageAccessState = (data) => {
    setDesignSystems((prevState) =>
      prevState.map((designSystem) => {
        if (designSystem.id !== data.id) {
          return designSystem;
        } else {
          return {
            ...designSystem,
            data,
          };
        }
      })
    );
  };
  const handleManageAccess = async (input, designSystemId) => {
    try {
      closeModal();
      setLoading(true);
      const data = await manageAccess(input, designSystemId);
      updateMamanageAccessState(data.data);
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to update memeber", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeDomainName = async (id, name) => {
    try {
      setLoading(true);
      const { data } = await updateDesignSystemDomainName(id, name);
      updateState(data);
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to rename domain", error);
    } finally {
      setLoading(false);
    }
  };

  const openUrlModal = () => {
    setURLModalOpen(true);
  };

  const UrlCloseModal = () => {
    setURLModalOpen(false);
  };

  const changePrivacy = (value) => {
    setSelectedType(value.value);
    setPrivacyConfirmModalOpenOpen(true);
  };

  const closePrivacyConfirmModal = () => {
    setPrivacyConfirmModalOpenOpen(false);
  };

  const handleChangePrivacy = async () => {
    try {
      setLoading(true);
      const { data } = await updateDesignSystemType(row?.id, {
        type: selectedType,
      });
      updateState(data);
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to update memeber", error);
    } finally {
      setLoading(false);
      closePrivacyConfirmModal();
    }
  };

  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModalOpenOpen(false);
  };
  const closeRenameModal = () => {
    setRenameModalOpen(false);
  };

  const handleRenameApply = async (name) => {
    if (!name) {
      toast.warning("Please enter name");
      return;
    }
    try {
      setLoading(true);
      const { data } = await renameDesignSystem(row.id, {
        design_system_name: name,
      });
      toast.success(data.message);
      updateRenameState(data);
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to rename the design system", error);
    } finally {
      setLoading(false);
    }
    closeRenameModal();
  };

  const closeAddMemberModal = () => {
    setAddMemberModalOpen(false);
  };

  const handleDesignSystemManageAccess = async (input, designSystemId) => {
    try {
      closeModal();
      setLoading(true);
      const data = await designSystemManageAccess(input, designSystemId);
      updateMamanageAccessState(data.data);
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to update memeber", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOnAddMember = (flag) => {
    setAddMemberModalOpen(flag);
    setSelectedData(row);
  };

  const handleTransferOwnership = async (email) => {
    try {
      setLoading(true);
      const data = await transferOwnership(row?.id, email);
      toast.success(data.message);
      deleteState(row?.id);
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to transfer the design system", error);
    } finally {
      setLoading(false);
      setTransferOwnershipModalOpen(false);
    }
  };
  const menuItems = [
    {
      id: 1,
      label: "Add members",
      action: () => {
        setAddMemberModalOpen(true);
        setSelectedData(row);
      },
    },
    {
      id: 2,
      label: " Rename",
      action: () => {
        setRenameModalOpen(true);
        setSelectedData(row);
      },
    },
    {
      id: 3,
      label: " Delete",
      action: () => setDeleteConfirmModalOpenOpen(true),
    },
    {
      id: 4,
      label: " Transfer ownership",
      action: () => setTransferOwnershipModalOpen(true),
    },
  ];

  const url = process.env.REACT_APP_SHEET_URL;

  return (
    <tr>
      <td>
        <div className="plt-ds-name d-flex align-items-center plt-body-sm plt-font-color-primary">
          {row?.design_system_name}
        </div>
      </td>
      <td>
        <div className="plt-url-wrapper d-flex plt-body-md plt-font-color-secondary">
          <a
            href={`/${row.id}/overview/getting-started`}
            className="plt-modal-link plt-role-description plt-ui-text-sm-medium"
          >
            {row?.domain?.domain_name
              ? `${row.domain.domain_name}.dessign.systems`
              : ""}
          </a>
          <AuthAction>
            <Permission designSystem={designSystemMeta}>
              <span className="dis-ml-12" onClick={openUrlModal}>
                <Tooltip
                  classPrefix="plt"
                  position="top"
                  label="Edit URL"
                  text=""
                >
                  <EditButton />
                </Tooltip>
              </span>
            </Permission>
          </AuthAction>
        </div>
      </td>
      <td>
        <div className="plt-asccess-description  plt-body-md plt-font-color-secondary">
          <span
            onClick={() => setModalOpen(true)}
            className="plt-modal-link plt-ui-text-sm-medium cursor-pointer d-block w-fit"
          >
            {row?.users_count} user(s)
          </span>
        </div>
      </td>
      <td>
        <div className="plt-owner-name d-flex align-items-center plt-body-sm plt-font-color-primary">
          <span className="dis-mr-12">
            <UserImage user={row?.admin} />
          </span>
          {row?.admin?.name}
        </div>
      </td>
      <td>
        <div className="privacy-dropdown">
          <SelectInput
            options={TYPE}
            selectedOption={selectedRole ?? "Select"}
            defaultValue={selectedPrivacyType}
            onSelect={(selectedValue) => changePrivacy(selectedValue)}
          />
        </div>
      </td>
      <td>
        <MenuDropdown menuItems={menuItems} setModalOpen={setModalOpen} />
      </td>
      <EditDesignsystemsModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        onApply={handleManageAccess}
        title="Manage access"
        data={row}
        onAddMember={handleOnAddMember}
      />
      <ConfirmDialog
        // footerClassName="plt"
        isOpen={isPrivacyConfirmModalOpenOpen}
        onRequestClose={closePrivacyConfirmModal}
        onApply={handleChangePrivacy}
        onApplyText="Change"
        title="Change design system privacy?"
        message="Are you sure to change privacy."
      />
      <ConfirmDialog
        // footerClassName="plt"
        isOpen={isDeleteConfirmModalOpenOpen}
        onRequestClose={closeDeleteConfirmModal}
        onApply={() => handleDeleteDesignSystem(row?.id)}
        onApplyText="Delete"
        title="Are you sure?"
        message="Are you sure to delete the design system."
      />
      <ChangeDomainNameModal
        isOpen={isUrlModalOpen}
        onRequestClose={UrlCloseModal}
        onApply={handleChangeDomainName}
        title="Edit URL"
        data={row}
      />
      <RenameModal
        isOpen={isRenameModalOpen}
        onRequestClose={closeRenameModal}
        onApply={handleRenameApply}
        title="Rename design system"
        data={row}
      />
      <AddMemberModal
        isOpen={isAddMemberModalOpen}
        onRequestClose={closeAddMemberModal}
        onApply={handleDesignSystemManageAccess}
        title="Add members"
        data={row}
      />
      {isAdmin && (
        <TransferOwnershipModal
          isOpen={isTransferOwnershipModalOpen}
          onRequestClose={closeTransferOwnershipModal}
          title="Transfer Ownership"
          onApply={handleTransferOwnership}
        />
      )}
    </tr>
  );
};

export default DesignsystemsTableRaw;
